import * as stylex from '@stylexjs/stylex';
import { MdPublic, MdLock, MdGroups, MdCake, MdPerson } from 'react-icons/md';
import { styles as page } from '~pages/Group/styles';
import { styles } from './styles';
import type { PublicGroup } from '~pages/Group/query';
const ICON_SIZE = 16;
export function Facts({
  group
}: {
  group: PublicGroup;
}) {
  return <div {...stylex.props(page.facts)}>
      <Visibility value={group.visibility} />
      <span {...stylex.props(styles.pill, styles.bgAges)}>
        <MdCake size={ICON_SIZE} {...stylex.props(styles.iconAges)} />
        Ages {group.ageRange.min}–{group.ageRange.max}
      </span>
      <Gender value={group.genderPolicy} />
    </div>;
}
function Visibility({
  value
}: {
  value: PublicGroup['visibility'];
}) {
  if (value === 'INVITE') {
    return <span {...stylex.props(styles.pill, styles.bgGender)}>
        <MdLock size={ICON_SIZE} {...stylex.props(styles.iconGender)} />
        Invite only
      </span>;
  }
  if (value === 'FRIENDS') {
    return <span {...stylex.props(styles.pill, styles.bgGender)}>
        <MdGroups size={ICON_SIZE} {...stylex.props(styles.iconGender)} />
        Friends
      </span>;
  }
  return <span {...stylex.props(styles.pill, styles.bgPublic)}>
      <MdPublic size={ICON_SIZE} {...stylex.props(styles.iconPublic)} />
      Public
    </span>;
}
function Gender({
  value
}: {
  value: PublicGroup['genderPolicy'];
}) {
  const Icon = value === 'MIXED' ? MdGroups : MdPerson;
  return <span {...stylex.props(styles.pill, styles.bgGender)}>
      <Icon size={ICON_SIZE} {...stylex.props(styles.iconGender)} />
      {value === 'MIXED' ? 'Mixed' : 'Single gender'}
    </span>;
}